module.exports = __webpack_public_path__ + "img/beaker-green.c9e8dc42.png";